import Utils from './utils';
import * as keys from './keys';
import ProductConstants from 'constants/ProductConstants';
import isObjectEmpty from 'utils/isObjectEmpty';


const initialDefaults = (formRef, data) => {
  let productData = data.data
  let biRequest = productData.bi_request;
  let frequency = biRequest.INPUT_MODE
  let pt = biRequest.PR_PT
  let ppt = biRequest.PR_PPT
  let familyIncomeBenefitOption = biRequest.FamilyIncomeBenefitOption
  let incomeBenefitPayOutType = biRequest.IncomeBenefitPayoutType
  let IncomeOption = biRequest.IncomeOption
  let incomeDuration = biRequest.IncomeDuration
  let PlanOption = biRequest.PlanOption
  let Increasing = biRequest.Increasing
  let Cashback = biRequest.Cashback
  let TimingofIncomeFromIncomeStartYear = biRequest.TimingofIncomeFromIncomeStartYear
  let SA_Multiple = biRequest.PR_SAMF
  let IncomeBenefitPayoutStartYear = biRequest.IncomeBenefitPayoutStartYear
  let laAge = biRequest.LI_ENTRY_AGE

  if (biRequest.SameProposer) {
    formRef.$('PayorWaiverBenefitRider').set('disabled', true)
  }

 // if (Increasing) {
  //   formRef.$('increasing').set('value', { id: Increasing, label: `${Increasing}%` })
  // }
  switch (Number(Increasing)) {
    case 11:
      formRef.$('increasing').set('value', { id: 11, label: "10%" })
      break;

    case 12:
      formRef.$('increasing').set('value', { id: 12, label: "20%" })
      break;

    case 13:
      formRef.$('increasing').set('value', { id: 13, label: "30%" })
      break;

    case 14:
      formRef.$('increasing').set('value', { id: 14, label: "40%" })
      break;

    case 15:
      formRef.$('increasing').set('value', { id: 15, label: "50%" })
      break;

    case 16:
      formRef.$('increasing').set('value', { id: 16, label: "60%" })
      break;

    case 17:
      formRef.$('increasing').set('value', { id: 17, label: "70%" })
      break;

    case 18:
      formRef.$('increasing').set('value', { id: 18, label: "80%" })
      break;

    case 19:
      formRef.$('increasing').set('value', { id: 19, label: "90%" })
      break;

    case 20:
      formRef.$('increasing').set('value', { id: 20, label: "100%" })
      break;

    default:
      break;
  }
  if (Number(pt)) {
    formRef.$('PT').set('value', { id: pt, label: pt })
  }
  let IncomeBenefitPayoutStartYearlist = Utils.PredefinedOptList(1, 21, Number(ppt))
  formRef.$("income-benefit-payout-start-year").set("extra", {
    ...formRef.$("income-benefit-payout-start-year").extra,
    isVisible: true,
    optionList: IncomeBenefitPayoutStartYearlist
  })
  if (Number(IncomeBenefitPayoutStartYear)) {
    let defaultValue = Number(IncomeBenefitPayoutStartYear) - 20;
    formRef.$('income-benefit-payout-start-year').set('value', { id: IncomeBenefitPayoutStartYear, label: defaultValue })

  }

  switch (Number(Cashback)) {
    case 35:
      formRef.$('cashback').set('value', { id: 35, label: 'Yes' })
      break;

    case 36:
      formRef.$('cashback').set('value', { id: 36, label: 'No' })
      break;
  }


  switch (Number(TimingofIncomeFromIncomeStartYear)) {
    case 37:
      formRef.$('timing-of-income-from-income-start-year').set('value', { id: 37, label: 'Start Of Year' })
      break;

    case 38:
      formRef.$('timing-of-income-from-income-start-year').set('value', { id: 38, label: 'End Of Year' })
      break;
  }

  switch (Number(SA_Multiple)) {
    case 5:
      formRef.$('sum-assure-multiple').set('value', { id: 5, label: '5' })
      break;
    case 7:
      formRef.$('sum-assure-multiple').set('value', { id: 7, label: '7' })
      break;
    case 10:
      formRef.$('sum-assure-multiple').set('value', { id: 10, label: '10' })
      break;
  }
  switch (Number(PlanOption)) {
    case 1:
      formRef.$('plan-option').set('value', { label: 'Lumpsum', id: '1' })

      formRef.$("income-option").set("extra", {
        ...formRef.$("income-option").extra,
        isVisible: false
      })

      formRef.$("cashback").set("extra", {
        ...formRef.$("cashback").extra,
        isVisible: false
      })
      formRef.$("increasing").set("extra", {
        ...formRef.$("increasing").extra,
        isVisible: false
      })
      formRef.$("cashback-percentage").set("extra", {
        ...formRef.$("cashback-percentage").extra,
        isVisible: false
      })
      formRef.$("timing-of-income-from-income-start-year").set("extra", {
        ...formRef.$("timing-of-income-from-income-start-year").extra,
        isVisible: false
      })
      formRef.$("income-duration").set("extra", {
        ...formRef.$("income-duration").extra,
        isVisible: false
      })
      let ptlist = []
      if (Number(ppt) >= 5 && Number(ppt) <= 8) {
        ptlist = Utils.PredefinedOptList(10, 10, 40);
      } else if (Number(ppt) >= 9 && Number(ppt) <= 12) {
        ptlist = Utils.PredefinedOptList(15, 15, 40);
      }
      formRef.$("PT").set("extra", {
        ...formRef.$("PT").extra,
        isVisible: true,
        optionList: ptlist
      })

      formRef.$("sum-assure-multiple").set("extra", {
        ...formRef.$("sum-assure-multiple").extra,
        isVisible: true,
        optionList: [
          { id: 5, label: '5' },
          { id: 7, label: '7' },
          { id: 10, label: '10' },
        ]
      })

      break;

    case 2:
      formRef.$('plan-option').set('value', { label: 'Income Plus Lumpsum', id: '2' })
      formRef.$('PT').set('disabled', true)
      let incomeDurationList = formRef.$('income-duration')?.extra?.optionList
      let income_DurationObj = incomeDurationList.find(item => Number(item?.id) === Number(incomeDuration))
      if (!isObjectEmpty(income_DurationObj)) {
        formRef.$('PT').set('value', { label: Number(income_DurationObj?.label) + Number(ppt) + 1, id: Number(income_DurationObj?.label) + Number(ppt) + 1 })
      }
      if (Number(ppt) >= 5 && Number(ppt) <= 7) {
        formRef.$("income-duration").set("extra", {
          ...formRef.$("income-duration").extra,
          isVisible: true,
          optionList: [
            { id: 4, label: '15' },
            { id: 5, label: '20' },
            { id: 6, label: '25' },
            { id: 7, label: '30' },
            { id: 8, label: '35' },
          ]
        })
      } else if (Number(ppt) >= 8 && Number(ppt) <= 12) {
        formRef.$("income-duration").set("extra", {
          ...formRef.$("income-duration").extra,
          isVisible: true,
          optionList: [
            { id: 3, label: '10' },
            { id: 4, label: '15' },
            { id: 5, label: '20' },
            { id: 6, label: '25' },
            { id: 7, label: '30' }
          ]
        })
      }
      let saMultipleList = []
      if (Number(laAge) >= 50) {
        saMultipleList = [
          { id: 5, label: '5' },
          { id: 7, label: '7' },
          { id: 10, label: '10' },
        ]
      } else {
        saMultipleList = [
          { id: 7, label: '7' },
          { id: 10, label: '10' },
        ]
      }

      formRef.$("sum-assure-multiple").set("extra", {
        ...formRef.$("sum-assure-multiple").extra,
        isVisible: true,
        optionList: saMultipleList
      })
      break;
  }

  formRef.$('PPT').value = { id: ppt, label: ppt };
  // ! income option (done)
  switch (Number(IncomeOption)) {
    case 9:
      formRef.$('income-option').set('value', { label: 'Level', id: 9 })
      formRef.$("increasing").set("extra", {
        ...formRef.$("increasing").extra,
        isVisible: false
      })
      break;

    case 10:
      formRef.$('income-option').set('value', { label: 'Increasing', id: 10 })
      break;
  }
  //  ! income duration
  switch (incomeDuration) {
    case '3':
      formRef.$('income-duration').set('value', { label: '10', id: '3' });
      break;

    case '4':
      formRef.$('income-duration').set('value', { label: '15', id: '4' })

      break;

    case '5':
      formRef.$('income-duration').set('value', { label: '20', id: '5' })
      break;

    case '6':
      formRef.$('income-duration').set('value', { label: '25', id: '6' })
      break;

    case '7':
      formRef.$('income-duration').set('value', { label: '30', id: '7' });
      break;

    case '8':
      formRef.$('income-duration').set('value', { label: '35', id: '8' });
      break;

    default:
      break;
  }


  // ! payment-frequency/input mode (done)
  switch (frequency?.toString()) {
    case '1':
      formRef.$('payment-frequency').set('value', {
        id: '1',
        label: 'Annual'
      })
      break;
    case '2':
      formRef.$('payment-frequency').set('value', {
        id: '2',
        label: 'Semi-Annual'
      })
      break;
    case '3':
      formRef.$('payment-frequency').set('value', {
        id: '3',
        label: 'Quarterly'
      })
      break;
    case '4':
      formRef.$('payment-frequency').set('value', {
        id: '4',
        label: 'Monthly'
      })
      break;

    default:
      break;
  }
  // ! end of payment-frequency


  // ! family income benefit (done)
  switch (Number(familyIncomeBenefitOption)) {

    case 3:
      formRef.$('family-income-benefit-option').set('value', false)
      break;
    case 4:
      formRef.$('family-income-benefit-option').set('value', true)

      formRef.$('family-income-benefit-option-dropdown').set('value', { label: 'Family Income Benefit on Critical Illness Critical Illness and Death', id: '4' })
      break;
    case 6:
      formRef.$('family-income-benefit-option').set('value', true)

      formRef.$('family-income-benefit-option-dropdown').set('value', { label: 'Family Income Benefit on Death', id: '6' })
      break;

    default:
      break;

  }
  // ! incomeBenefitPayOutType (done)
  switch (incomeBenefitPayOutType) {

    case '5':
      formRef.$('income-benefit-pay-out-type').set('value', { label: 'Level', id: '5' })
      break;
    case '6':
      formRef.$('income-benefit-pay-out-type').set('value', { label: 'Increasing', id: '6' })
      break;


    default:
      break;
  }
  // ! end of incomeBenefitPayOutType

  formRef.$("payment-frequency").set("extra", {
    ...formRef.$("payment-frequency").extra,
    optionList: [
      { label: 'Annual', id: '1' },
      { label: 'Semi-Annual', id: '2' },
      { label: 'Quarterly', id: '3' },
      { label: 'Monthly', id: '4' }
    ],
  })

  if (biRequest.ADBRider) {
    formRef.$('ADB').set('value', biRequest.ADBRider !== '')
    if (biRequest.ADBRider) {
      formRef.$('ADB-dropdown').set('value', biRequest.ADBRider)
    }
  }
  if (biRequest.ATPDRider) {
    formRef.$('ATPDRider').set('value', biRequest.ATPDRider !== '')
    if (biRequest.ATPDRider) {
      formRef.$('ATPDRider-dropdown').set('value', biRequest.ATPDRider)
    }
  }
  if (biRequest.WaiverOfPremiumRider) {
    formRef.$('WaiverOfPremiumRider').set('value', biRequest.WaiverOfPremiumRider !== '')
  }
  if (biRequest.HospitalityCashBenefitRider) {
    formRef.$('HospitalityCashBenefitRider').set('value', biRequest.HospitalityCashBenefitRider !== '')
    if (biRequest.HospitalityCashBenefitRider) {
      formRef.$('HospitalityCashBenefitRider-dropdown').set('value', biRequest.HospitalityCashBenefitRider)
    }
  }
  if (biRequest.CriticalIllnessRider) {
    formRef.$('CriticalIllnessRider').set('value', biRequest.CriticalIllnessRider !== '')
    if (formRef.$('CriticalIllnessRider').value) {
      formRef.$('CriticalIllnessRider-dropdown').set('value', biRequest.CriticalIllnessRider)
    }
  }
  if (biRequest.PayorWaiverBenefitRider) {
    formRef.$('PayorWaiverBenefitRider').set('value', biRequest.PayorWaiverBenefitRider !== '')
    if (formRef.$('PayorWaiverBenefitRider').value) {
      switch (biRequest.PWB) {
        case '1':
          formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
            id: '1',
            label: 'Option 1 (On Death)'
          })
          break;
        case '2':
          formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
            id: '2',
            label: 'Option 2 (CI or ATPD)'
          })
          break;
        case '3':
          formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
            id: '3',
            label: 'Option 3 (CI or ATPD or Death)'
          })
          break;
        default:
          break;
      }
    }
  }
}

export default initialDefaults